import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConfigurationApi, applicationSettingApi } from '../interfaces/configuration.interface';
import { LocalStorage } from '../helpers/localstorage.helper';
import { jwtDecode } from 'jwt-decode';
import { AppBrandingSettingView } from '../../modules/admin/pages/system-theme/models/app-branding-setting-view';



@Injectable({
    providedIn: 'root'
})
export class AppDataService {

    private _configurations: any = {};
    public _applicationSetting: any = {};
    private rootApiUrl = environment.spaUrl + 'apis'
    private _brandingSettings: any = {};
    constructor(private httpClient: HttpClient) {
    }

    LoadConfigurations() {
        
        const accessToken = LocalStorage.get('auth')?.id_token;
       
        const headers = {
            'allow-business-error-toaster': 'allow',
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            Authorization: `Bearer ${accessToken}`,
        };

        const openConfig$ = this.httpClient.get(`${this.rootApiUrl}/api/v1/OpenConfiguration`, { headers });

        let appSettings$: Observable<any> = of(null);
        let brandingSettings$: Observable<any> = of(null);
        brandingSettings$ = this.httpClient.get(`${this.rootApiUrl}/api/v1/AppBranding/Get`, { headers });

        if (this.isAuthenticated()) {
            appSettings$ = this.httpClient.get(`${this.rootApiUrl}/api/v1/GeneralSettings/GetApplicationSettings`, { headers });

        }

        return forkJoin({ openConfig: openConfig$, appSettings: appSettings$, brandingSettings: brandingSettings$ }).pipe(
            tap(({ openConfig, appSettings, brandingSettings  }) => {
                this._configurations =  openConfig;
                this._applicationSetting = appSettings;
                this._brandingSettings = brandingSettings;
                if (appSettings) { 
                    LocalStorage.set('calendar', appSettings.calendarType == "Hijri" ? "Umalqura" : appSettings.calendarType);
                }
            })
        );
    }
  
    public get configurations(): ConfigurationApi {

        if (this._configurations.rootApiUrl == undefined) {
            this._configurations.rootApiUrl = this.rootApiUrl;
        }

        if (this._configurations.rootUrl == undefined) {
            this._configurations.rootUrl = environment.spaUrl;
        }
        return this._configurations;
    }

    public get applicationSettings(): applicationSettingApi {
        return this._applicationSetting;
    }
    public get brandingSettings(): AppBrandingSettingView {
        return this._brandingSettings;
    }
    private isAuthenticated() {
        const authToken = LocalStorage.get('auth');
        let decoded: any = '';
        try {
            const id_token: any = LocalStorage.get('auth')?.id_token;
            decoded = jwtDecode(id_token) as any;
        }
        catch (error) {
            const id_token: any = LocalStorage.get('auth')?.id_token;
            if (!!id_token)
                decoded = jwtDecode(id_token) as any;
        }

        if (authToken && (new Date(decoded?.['exp'] * 1000).getTime() > new Date().getTime())) {
            return true;
        } else {
            return false;
        }
    }
}
